import { ErrorBoundary } from '@components/shared/ErrorBoundary';
import GameContainer from '@features/game/components/GameContainer';

export default function SlidingPuzzlePage() {
  return (
    <ErrorBoundary>
      <GameContainer />
    </ErrorBoundary>
  );
}
